/**
 * @generated SignedSource<<8dac2fe8cbe997ee442d3c6b0e85e237>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RequestShippingSuccessContent_seller$data = {
  readonly " $fragmentSpreads": FragmentRefs<"FollowDealerButton_seller">;
  readonly " $fragmentType": "RequestShippingSuccessContent_seller";
};
export type RequestShippingSuccessContent_seller$key = {
  readonly " $data"?: RequestShippingSuccessContent_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"RequestShippingSuccessContent_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RequestShippingSuccessContent_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FollowDealerButton_seller"
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "25f08c065b495b3b34ff55f8975acff2";

export default node;
